import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { projects, projectSectors } from '../data/projects';
type Sector = (typeof projectSectors)[number];
export function ProjectPortfolio() {
  const [filter, setFilter] = useState<Sector>('All');
  const visible = useMemo(() => filter === 'All' ? projects : projects.filter(project => project.sector === filter), [filter]);
  return <section id="portfolio" className="scroll-mt-16 bg-canvas" data-id="element-174" data-mp="3nwqnmlysvu4w">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-28" data-id="element-175" data-mp="3nuw5tgitsi51">
        <SectionHeading index="IV" title="Representative Capital Programs" description="Selected healthcare, aviation, civic, and commercial programs delivered across a 35-year construction executive career." data-id="element-176" data-mp="39yivcrcplh02" />

        <div role="group" aria-label="Filter programs by sector" className="mt-10 flex flex-wrap gap-2" data-id="element-177" data-mp="1d4nupfdtd05o">
          {projectSectors.map(sector => {
          const selected = sector === filter;
          return <button key={sector} type="button" aria-pressed={selected} onClick={() => setFilter(sector)} className={['focus-ring whitespace-nowrap rounded-sm border px-4 py-2 text-xs font-semibold uppercase tracking-wider transition-colors duration-150 ease-exec', selected ? 'border-navy bg-navy text-white' : 'border-steel-200 bg-white text-steel-400 hover:border-navy hover:text-navy'].join(' ')} data-id="element-178" data-mp="14lla4dh8kmax">
                {sector}
              </button>;
        })}
        </div>

        <ul className="mt-12 grid gap-8 lg:grid-cols-2" data-id="element-179" data-mp="2b0m6ule358ik">
          {visible.map((project, i) => <motion.li key={project.name} layout initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          delay: Math.min(i, 3) * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col bg-white" data-id="element-180" data-mp="26217spakkuvp" data-mpi={i}>
              <img src={project.image} alt={`${project.name} in ${project.location}`} className="aspect-[3/2] w-full object-cover" data-id="element-181" data-mp="2s1yrxtyvkywu" />
              <div className="flex flex-1 flex-col p-8" data-id="element-182" data-mp="1zfnp0cnsqlwv">
                <div className="flex items-center justify-between gap-4" data-id="element-183" data-mp="24dpbl7kfl3d3">
                  <span className="text-[11px] font-semibold uppercase tracking-overline text-bronze-600" data-id="element-184" data-mp="24bm9vq9x1lsj">
                    {project.sector}
                  </span>
                  <span className="font-serif text-xl text-navy" data-id="element-185" data-mp="1bo8kcd8jrsig">
                    {project.value}
                  </span>
                </div>
                <h3 className="mt-4 font-serif text-2xl leading-snug text-navy" data-id="element-186" data-mp="194lo6tfvda27">
                  {project.name}
                </h3>
                <p className="mt-2 text-sm text-steel-400" data-id="element-187" data-mp="1459065d9hwy1">{project.location}</p>
                <p className="mt-5 text-sm leading-relaxed text-steel-400" data-id="element-188" data-mp="z5whlwtfbc19">
                  {project.description}
                </p>
                <div className="mt-auto pt-6" data-id="element-189" data-mp="u6jjuh10kkjw">
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-steel-100 pt-5" data-id="element-190" data-mp="q5ra7mo8cdn3">
                    {project.facts.map(fact => <span key={fact} className="text-xs font-semibold text-navy-700" data-id="element-191" data-mp="ldq0o8ig510r">
                        {fact}
                      </span>)}
                  </div>
                  <p className="mt-3 text-xs font-medium uppercase tracking-wider text-steel-400" data-id="element-192" data-mp="6i0cc3psgbsv">
                    Role — {project.role}
                  </p>
                </div>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}